import React, { useState,useEffect,useMemo } from 'react';
import { Tabs, Dropdown, Menu, Modal, Form, Input, Button, Select, Space,Radio   } from 'antd';
import { get,post } from '../../Services/Api';
import Loading from '../../Components/Loading';
import AdminSidebar from '../../Components/AdminSidebar';
import AddImg from './../../Assets/images/white-add.svg';
import SearchIconImg from '../../Assets/images/search.svg';
import GridIconImg from '../../Assets/images/grid-view.svg';
import ListIconImg from '../../Assets/images/list-view.svg';
import FilterImg from '../../Assets/images/filter-edit.svg';
import DummyImg from '../../Assets/images/dummy-img.png';
import { DownOutlined, SmileOutlined } from '@ant-design/icons';
import {  Drawer } from 'antd';
import InfoImg from './../../Assets/images/info.svg';
import { notification } from 'antd';
import debounce from "lodash.debounce"; 
import eyeClose from '../../Assets/images/eyeclose.svg'
import eyeOpen from '../../Assets/images/eyeopen.svg'
import userImg3 from '../../Assets/images/user3.png'
import userImg4 from '../../Assets/images/user4.png'
import userImg5 from '../../Assets/images/user5.png'
import userImg6 from '../../Assets/images/user6.png'
import userImg7 from '../../Assets/images/user7.png'
import Avatar1 from '../../Assets/images/avatar.png'
import {Checkbox  } from 'antd';
import DeleteImg from '../../Assets/images/delete-black.svg';
import DeleteConformation from '../../Components/DeleteConformation';




const UserManagement = () => {
  const [showPassword, setShowPassword] = useState(false);
  const [open, setOpen] = useState(false);
  const [userList,setuserList] =useState([]);
  const [loading,setLoading] =useState(false);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const [userSearchquery,setuserSearchquery] = useState("");
  const [AddformValues, setFormValues] = useState({
    firstName: "",
    lastName: "",
    email: "",
    password: "",
    role: "user", 
  });
  const [errors, setErrors] = useState({});
  const [selectedTemplates, setSelectedUsers] = useState([]);
  const [sortOrder, setSortOrder] = useState('asc');

  const [isDeleteModalVisible, setDeleteModalVisible] = useState(false);
  const [selectedUserId, setSelectedUserId] = useState(null);
  const [isMultiDeleteModalVisible, setMultiDeleteModalVisible] = useState(false);

  const validateEmail = (email) => {
    // Regex for basic email validation
    // const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const emailRegex = /^[a-zA-Z0-9](?!.*\.\.)[a-zA-Z0-9._%+-]*@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return emailRegex.test(email);
  };

  const validateFields = () => {
    const newErrors = {};
    if (!AddformValues.firstName.trim()) newErrors.firstName = "First Name is required.";
    if (!AddformValues.lastName.trim()) newErrors.lastName = "Last Name is required.";
    // if (!AddformValues.email.trim()) newErrors.email = "Email is required.";
    if (!AddformValues.password.trim()){ 
      newErrors.password = "Password is required.";

    }  else if (AddformValues.password.length < 8) {
      newErrors.password = "Password must be at least 8 characters long.";
    }
    // Validation for email
    if (!AddformValues.email.trim()) {
      newErrors.email = "Email is required.";
    } else if (!validateEmail(AddformValues.email)) {
      newErrors.email = "Please enter a valid email address.";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };


  const validateEditFields = () => {
    const newErrors = {};
  
    if (!selectedUser.first_name.trim()) newErrors.first_name = "First Name is required.";
    if (!selectedUser.last_name.trim()) newErrors.last_name = "Last Name is required.";
  
    // Email validation
    if (!selectedUser.username.trim()) {
      newErrors.username = "Email is required.";
    } else if (!validateEmail(selectedUser.username)) {
      newErrors.username = "Please enter a valid email address.";
    }
  
    // Password validation (at least 8 characters)
    if (selectedUser.userpassword && selectedUser.userpassword.length < 8) {
      newErrors.userpassword = "Password must be at least 8 characters long.";
    }
  
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };
 

  // const userImages = [userImg1, userImg2, userImg3, userImg4, userImg5, userImg6, userImg7];
  // const getRandomImage = () => userImages[Math.floor(Math.random() * userImages.length)];

const showAddUserDrawer = () => {
  // console.log("drawer opened")
  setErrors({})
  setFormValues({
    firstName: "",
    lastName: "",
    email: "",
    password: "",
    role: "user", 
  });
  setShowPassword(false)
  setOpen(true);
};

  // Function to handle input changes
  const handleAddUserInputChange = (field, value) => {
    // Allow only alphabets for First Name and Last Name
    if (field === "firstName" || field === "lastName") {
      if (!/^[A-Za-z]*$/.test(value)) {
        return; // Ignore the input if it contains non-alphabet characters
      }
    }
    setFormValues((prev) => ({
      ...prev,
      [field]: value,
    }));
    setErrors((prev) => ({
      ...prev,
      [field]: value.trim() ? "" : "This field is required.",
    }));
  };

  const handleAddUserSubmit =  async ()=>{

    if (!validateFields()) {
      return; // Stop submission if validation fails
    }
    
    const payload = {
      username: AddformValues.email,
      userpassword: AddformValues.password,
      first_name: AddformValues.firstName,
      last_name: AddformValues.lastName,
      roles: AddformValues.role,
    };

    // console.log("AddformValues Payload::",AddformValues);

    try {
      await post('adduser', payload);

      // Show success notification
      notification.success({
        message: 'User Added',
        description: `${AddformValues.firstName} ${AddformValues.lastName} has been successfully added.`,
        placement: 'topRight',
      });

      // Close drawer and refresh the user list
      setOpen(false);
      fetchUserList();
    } catch (error) {
      if (error?.response?.status === 409) {
        // Handle conflict (user already exists)
        notification.error({
          message: "User Already Exists",
          description: error?.response?.data?.error || "A user with this username already exists.",
          placement: "topRight",
        });
      } else {
        // Generic error handling
        notification.error({
          message: "Error Adding User",
          description: "There was an error adding the user. Please try again later.",
          placement: "topRight",
        });
      }
    }
    
  }

  
  const handleModalOk =  async () => {

    if (!validateEditFields()) {
      return; // Stop submission if validation fails
    }

    // const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    const emailRegex = /^[a-zA-Z0-9](?!.*\.\.)[a-zA-Z0-9._%+-]*@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

    if (
      !selectedUser.first_name ||
      !selectedUser.last_name ||
      !selectedUser.username ||
      !selectedUser.userpassword ||
      !selectedUser.roles
    ) 
    {
      // Show error notification if any field is empty
      notification.error({
        message: "Validation Error",
        description: "All fields are required. Please fill in the missing information.",
        placement: "topRight",
      });
      return; // Prevent submission
    }

    if (!emailRegex.test(selectedUser.username)) {
      notification.error({
        message: "Validation Error",
        description: "Please enter a valid email address.",
        placement: "topRight",
      });
      return; // Prevent submission
    }

    

    const admin_id = selectedUser.admin_id;
   
    const payload = {
      username: selectedUser.username,
      userpassword: selectedUser.userpassword,
      first_name: selectedUser.first_name,
      last_name: selectedUser.last_name,
      roles: selectedUser.roles
    }
    try {
      // Make API call to update the user
      await post(`edituser/${admin_id}`, payload);
      // await post(`http://192.168.96.120:5000/apis/edituser/${admin_id}`, payload);
  
      // Update user in the state directly
      setuserList((prevUserList) =>
        prevUserList.map((user) =>
          user.admin_id === admin_id ? { ...user, ...payload } : user
        )
      );
  
      // Show success notification
      notification.success({
        message: 'User Updated',
        description: `${selectedUser.first_name} ${selectedUser.last_name} has been successfully updated.`,
        placement: 'topRight',
      });
  
      setIsModalVisible(false); // Close the modal
    } catch (error) {

      if (error?.response?.status === 409) {
        // Handle conflict (user already exists)
        notification.error({
          message: "User Already Exists",
          description: error?.response?.data?.error || "A user with this username already exists.",
          placement: "topRight",
        });
      } else {
        // Generic error handling
        notification.error({
          message: 'Error Updating User',
          description: 'There was an error updating the user. Please try again later.',
          placement: 'topRight',
        });
      }     
    }
    
    // setIsModalVisible(false);
  };
  
  const handleModalCancel = () => {
    setIsModalVisible(false);
  };
  // 
  useEffect(() => {
    fetchUserList();
  }, []);

  const fetchUserList = async () => {
    setLoading(true);
    try {
      const response = await get('listuser'); // Fetch updated user list
      const sortedList = response.data.sort((a, b) => a.first_name.localeCompare(b.first_name)); // Default ascending sort
      setuserList(sortedList); // Update the state
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleUserSearch = debounce((query) => {
    setuserSearchquery(query);
  },300);

  const filtereduserList = useMemo(()=>{
    if (!userSearchquery) return userList;
    return userList.filter((user) =>user.first_name.toLowerCase().includes(userSearchquery.toLowerCase())||
    user.last_name.toLowerCase().includes(userSearchquery.toLowerCase())||
    user.username.toLowerCase().includes(userSearchquery.toLowerCase())
    );
  },[[userList, userSearchquery]])


  const items = [
    {
      key: '1',
      label: (
        <a 
        target="_blank"
        rel="noopener noreferrer"
        href=""
        onClick={(e) => {
          e.preventDefault();
          sortUserList('asc'); 
        }}
        >
          Ascending
        </a>
      ),
    },
    {
      key: '2',
      label: (
        <a 
        target="_blank"
        rel="noopener noreferrer" 
        href=""
        onClick={(e) => {
          e.preventDefault();
          sortUserList('desc'); 
        }}
        >
          Descending
        </a>
      ),
    }
    // {
    //   key: '3',
    //   label: (
    //     <a target="_blank" rel="noopener noreferrer" href="">
    //       3rd menu item (disabled)
    //     </a>
    //   ),
    // },
  ];
  

  const sortUserList = (order) => {
    const sortedList = [...userList].sort((a, b) => {
      if (order === 'asc') {
        return a.first_name.localeCompare(b.first_name);
      } else {
        return b.first_name.localeCompare(a.first_name);
      }
    });
    setuserList(sortedList);
    setSortOrder(order);
  };

  const showModal = (id) => {
    setShowPassword(false)
    const user = userList.find((user) => user.admin_id === id);
    // setSelectedUser(user);
    // setIsModalVisible(true);
    if (user) {
      setSelectedUser(user); // Update the state with the selected user
      setTimeout(() => {
        setIsModalVisible(true); // Open the modal after ensuring the state is updated
      }, 0);
    }    
  };

  // console.log("selectedUser::",selectedUser);


  const onClose = () => {
    setOpen(false);
  };

  const onChangesFilter = (value, option) => {
    console.log("Selected:", value);
  };
  
  const onChanges = (value, option) => {
    console.log("Selected value:", value);
  };
  const onSearch = (searchTerm) => {
    console.log("Search term:", searchTerm);
  };

  
  const deleteUser = async (userId)=>{
    setSelectedUserId(userId);
  setDeleteModalVisible(true);
 

  }
  const handleDeleteModalCancel = () => {
    setDeleteModalVisible(false);
    setSelectedUserId(null);
  };

  const customDelete = async () => {
    if (!selectedUserId) return;
  
    try {
      const response = await post(`deleteuser/${selectedUserId}`);
      if (response?.status === 200) {
        notification.success({
          message: "User Deleted Successfully",
          description: "",
        });
        fetchUserList();
      } else {
        notification.error({
          message: "Error Deleting User",
          description: "There was an error while deleting the user. Please try again.",
        });
      }
    } catch (error) {
      console.error("Error deleting user:", error);
    } finally {
      setDeleteModalVisible(false);
      setSelectedUserId(null);
    }
  };

   const getMenuItems = (id) => {
    // Define unique items for each dropdown if needed
    return [
      {
        key: `edit-${id}`,
        label: (
          <a
          href="#"
          onClick={(e) => {
            e.preventDefault();
            showModal(id); // Show modal for the selected user
          }}
          style={{ minWidth: '100px' }}
        >
            Edit
          </a>
        ),
      },
      {
        key: `delete-${id}`,
        label: (
          <a
            href="#"
            onClick={(e) => {
              e.preventDefault(); 
              deleteUser(id);     
            }} 
            style={{minWidth: '100px'}}
          >
            Delete
          </a>
        ),
      },
    ];
  };

  const handleCheckingUsers = (userId,isChecked)=>{
    // setSelectedUsers((prev)=>{
    //     if(isChecked){
    //         return [...prev,userId]
    //     }else{
    //         return prev.filter((id)=>id !== userId)
    //     }
    // })
    setSelectedUsers((prev)=>{
      const updatedSelection = new Set(prev);
      if (isChecked){
        updatedSelection.add(userId)
      }
      else{
        updatedSelection.delete(userId);
      }
      return Array.from(updatedSelection)
    })
}

const showMultiDeleteModal = () => {
  if (selectedTemplates.length === 0) {
    notification.warning({
      message: "No Users Selected",
      description: "Please select Users to delete.",
    });
    return;
  }
  setMultiDeleteModalVisible(true);
};

const handleMultiDeleteCancel = () => {
  setMultiDeleteModalVisible(false);
};

const handleMultipleDelete = async ()=>{
  if (selectedTemplates.length === 0) {
      notification.warning({
        message: 'No Users Selected',
        description: 'Please select Users to delete.',
      });
      return;
    }
  
    try {
      const response = await post('multipledeleteuser', {
        admin_ids: selectedTemplates,
      });
  
      if (response.status === 200) {
        notification.success({
          message: 'Users Deleted Successfully',
        });
        setMultiDeleteModalVisible(false);
  
        // Remove deleted templates from the list
        setuserList((prevList) =>
          prevList.filter((template) => !selectedTemplates.includes(template.template_id))
        );
  
        // Clear selection
        setSelectedUsers([]);
        fetchUserList();
      } else {
        throw new Error('Failed to delete Users');
      }
    } catch (error) {
      console.error('Error deleting users:', error);
      notification.error({
        message: 'Error Deleting Users',
        description: 'An error occurred while deleting the Users.',
      });
    }
  
}



    return (
        <>
        
            <div className="row ">
              <div className="d-flex align-items-center">
              <AdminSidebar />
              <div className="col-size-8">
                    <div className="inside-filter">
                    {loading ?(
                        <div>
                            <Loading/>
                        </div>
                    ):( <>
                      <div className="d-flex align-items-center justify-content-between">
                          <div>
                          <h4>
                            User Management
                            </h4>
                            <p>
                            Manage your users
                            </p>
                          </div>
                          <div className="my-2 d-flex align-items-center position-relative">
                            
                            <input 
                            type="search"
                            className="form-control pe-5"
                            placeholder="Search by name"
                            onChange={(e)=>{
                              e.preventDefault()
                              handleUserSearch(e.target.value)
                          }}
                            />
                            <span className="position-absolute top-4" style={{right: '10px'}}>
                            <img src={SearchIconImg} alt="" style={{width: '18px'}} />
                            </span>
                        </div>
                      </div>
                      {/*  */}
                      <div className="d-flex align-items-center justify-content-between">
                          <h5>Users  <span style={{color: '#73DC9B'}}>{filtereduserList.length}</span></h5>
                          <div className="d-flex align-items-center">
                            <div className="dropdown d-flex align-items-center">
                            {selectedTemplates.length > 1 &&(
                            <div className="user-multi-delete me-5">
                                <a 
                                href="#"
                                onClick={(e)=>{
                                    e.preventDefault();
                                    showMultiDeleteModal()
                                }
                                }
                                >
                                    <img src={DeleteImg} alt="" />
                                </a>
                                </div>
                            )}
                              <p className="mb-0 me-2" style={{color: '#9C9C9C'}}>Sort by:</p>
                            <Dropdown
                                menu={{
                                  items,
                                }}
                                placement="bottomRight"

                              >
                                <a onClick={(e) => e.preventDefault()}  style={{cursor:'pointer', color:'#000'}}>
                                  <Space>
                                  {sortOrder === 'asc' ? 'Ascending' : 'Descending'}
                                    <DownOutlined />
                                  </Space>
                                </a>
                              </Dropdown>
                            </div>
                            {/* <div className="list-view-user">
                                <div className="list-view-user-img1 list-view-user-img2">
                                  <img src={GridIconImg} alt="" className="" />
                                </div>
                                <div className="list-view-user-img1">
                                  <img src={ListIconImg} alt="" className="" style={{width: '19px'}} />
                                </div>
                            </div> */}
                            <div className="user-btn ms-3">
                              <button className="btn btn-primary" onClick={showAddUserDrawer}>
                                <img src={AddImg} alt="" className="me-3" />
                                Add User
                              </button>
                            </div>
                          </div>
                     </div>
                     {/*  */}
                     {/* <div> */}
                     {filtereduserList.length > 0 ? (
                     <ul className="row">
                      {/* {userList.map((item) => ( */}
                      {filtereduserList.map((item) => (
                        <li className="col-lg-4 mt-4 w-50-col" key={item.admin_id}>
                          <div className="grid-view-box">
                            <div className="d-flex align-items-center">
                            <div className="d-flex align-items-center me-2">
                              <Checkbox 
                              className="me-2"
                              checked={selectedTemplates.includes(item.admin_id)} 
                              onChange={(e)=>{
                                handleCheckingUsers(item.admin_id,e.target.checked)
                            }} 
                              />
                              
                          </div>
                              <div className="grid-view-box-img">
                                {/* <img src={DummyImg} alt={item.first_name} className="" /> */}
                                <img src={Avatar1} alt={item.first_name} className="" />
                              </div>
                              <div className="grid-content">
                                <h6 className="mb-0">{item.first_name} {item.last_name}</h6>
                                <p className="mb-0">{item.username}</p>
                              </div>
                            </div>
                            <div>
                              <Dropdown
                                menu={{
                                  items: getMenuItems(item.admin_id), // Generate unique menu items
                                }}
                                // trigger={['click']}
                                placement="bottomRight"
                                
                              >
                                <a onClick={(e) => e.preventDefault()} >
                                  <Space className="px-2 py-2">
                                    <img src={FilterImg} alt="Filter" className="cursor-pointer" />
                                  </Space>
                                </a>
                              </Dropdown>
                            </div>
                          </div>
                        </li>
                      ))}
                    </ul>
                     ) : (
                      <div className='d-flex justify-content-center align-items-center' style={{height:'72%'}}>
                        <p className="text-center">No records found</p>
                      </div>
                    )}
                     {/* </div> */}
                   {/*  */}
                   </>)}
                    </div>
                </div>
              </div>          
            </div>
            
             {/* Ant Design Modal */}
            <Modal
              title={`Edit User`}
              visible={isModalVisible}
              onOk={handleModalOk}
              onCancel={handleModalCancel}
              okText="Save Changes" 
              cancelText="Discard" 
              okButtonProps={{
                style: {
                  borderRadius: '20px',
                  minWidth: '150px',
                  padding: '1.2rem 0.75rem'
                }
              }}
              cancelButtonProps={{
                style: {
                  borderRadius: '20px',
                  minWidth: '150px',
                  padding: '1.2rem 0.75rem'
                }
              }}
            >
            
              {selectedUser && (
                <div style={{ display: "flex", flexDirection: "column", gap: "16px" }}>
                  <div style={{ display: "flex", flexDirection: "column", marginTop: "16px" }}>
                    <label>First Name</label>
                    <input
                      type="text"
                      name="First Name"
                      value={selectedUser.first_name || ""}
                      onChange={(e) => {
                        const value = e.target.value;
                        if (/^[A-Za-z]*$/.test(value) && value.length<=20) {
                          // Allow only alphabets
                        setSelectedUser({ ...selectedUser, first_name: value })
                        }
                      }
                    
                    }
                      // className="form-control"
                      className={`form-control ${errors.first_name ? 'is-invalid' : ''}`}
                    />
                    {errors.first_name && <div className="invalid-feedback">{errors.first_name}</div>}
                  </div>
                  <div style={{ display: "flex", flexDirection: "column" }}>
                    <label>Last Name</label>
                    <input
                      type="text"
                      name="Last Name"
                      value={selectedUser.last_name || ""}
                      onChange={(e) => {
                        const value = e.target.value;
                        if (/^[A-Za-z]*$/.test(value) && value.length<=20) {
                        setSelectedUser({ ...selectedUser, last_name: value })}
                      }
                      }
                      className={`form-control ${errors.last_name ? 'is-invalid' : ''}`}
                    />
                    {errors.last_name && <div className="invalid-feedback">{errors.last_name}</div>}
                  </div>
                  <div style={{ display: "flex", flexDirection: "column" }}>
                    <label>Email</label>
                    <input
                      type="email"
                      name="username"
                      value={selectedUser.username || ""}
                      onChange={(e) => setSelectedUser({ ...selectedUser, username: e.target.value })}
                      className={`form-control ${errors.username ? 'is-invalid' : ''}`}
                    />
                    {errors.username && <div className="invalid-feedback">{errors.username}</div>}
                  </div>
                  <div style={{ display: "flex", flexDirection: "column", marginBottom: "15px" }}>
                    <label>Password</label>
                    <div className="position-relative">
                    <input
                       type={`${showPassword ? "text" : "password"}`}
                      name="Password"
                      value={selectedUser.userpassword || ""}
                      onChange={(e) => setSelectedUser({ ...selectedUser, userpassword: e.target.value })}
                      className={`form-control ${errors.userpassword ? 'is-invalid' : ''}`}
                    />
                    {errors.userpassword && <div className="invalid-feedback">{errors.userpassword}</div>}
                  
                  <div
                  className="icon-eye"
                  onClick={() => {
                    setShowPassword(!showPassword);
                  }}
                >
              
                  <img src={showPassword ? eyeOpen : eyeClose} alt="" style={{width:'15px'}} />
                </div>
                
                    </div>
                  </div>

                  <div className="form-group">
            <label>Role</label>
            <div>
              <Radio
                checked={selectedUser.roles === "admin"}
                onChange={(e) => setSelectedUser({ ...selectedUser, roles: "admin" })}
              >
                Admin
              </Radio>
              <Radio
                checked={selectedUser.roles === "user"}
                onChange={(e) => setSelectedUser({ ...selectedUser, roles: "user" })}
              >
                User
              </Radio>
            </div>
          </div>
                </div>
              )}
            </Modal>
            {/*  */}
            {/* <Drawer title="Add User" onClose={onClose} open={open} width={620}>
        <div className="w-100 d-flex align-items-center info-msg mb-4">
            <img src={InfoImg} className="" style={{width: '20px'}} />
          <p className="mb-0 ms-4">Please enter the details </p>
        </div>
        <div className="drawer-style">
      <Form 
      layout="vertical"
      >
        
          <Form.Item
              label="First Name"
              name="firstName"
              rules={[
                { required: true, },
            ]}
          >
              <Input 
              placeholder="Please Enter Name" 
              type="text"
              defaultValue={AddformValues.firstName}
              onChange={(e)=>handleAddUserInputChange("firstName",e.target.value)}
              />
              
          </Form.Item>
          <Form.Item
              label="Last Name"
              name="lastName"
              rules={[
                { required: true, },
            ]}
          >
              <Input 
              placeholder="Please Enter Name" 
              type="text"
              defaultValue={AddformValues.lastName}
              onChange={(e)=>handleAddUserInputChange("lastName",e.target.value)}
              />
          </Form.Item>
          <Form.Item
              label="Email"
              name="user email"
              rules={[
                { required: true, message: 'Please Enter Email' },
            ]}
          >
              <Input 
              placeholder=""
              type="email"
              defaultValue={AddformValues.email}
              onChange={(e)=>handleAddUserInputChange("email",e.target.value)} 
               />
          </Form.Item>
          <Form.Item
              label="Password"
              name="user password"
          >
              <Input 
              placeholder=""
              type="password"
              defaultValue={AddformValues.password}
              onChange={(e)=>handleAddUserInputChange("password",e.target.value)}
              />
          </Form.Item>

          <Form.Item
          label="Role"
          name="role"
          rules={[{ required: true, message: 'Please select a role' }]}
      >
          <Radio.Group
              // onChange={(e) => handleRoleChange(e.target.value)} // Handle the role change
              defaultValue={AddformValues.role}
          >
              <Radio value="admin">Admin</Radio>
              <Radio value="user">User</Radio>
          </Radio.Group>
    </Form.Item>
      </Form>
      
      </div>
      <div className="d-flex align-items-center justify-content-end w-100 mt-4">
      <button  className="me-4 btn" onClick={onClose}>
                  Cancel
              </button>
              <button className="btn btn-primary" onClick={handleAddUserSubmit}>
                  Add
              </button>
      </div>
      </Drawer> */}
      <Drawer
        title="Add User"
        anchor="right"
        open={open}
        onClose={onClose}
        width={620}
      >
        {/* <div className="w-100 d-flex align-items-center info-msg mb-4">
          <img src={InfoImg} className="" style={{ width: "20px" }} alt="info" />
          <p className="mb-0 ms-4">Please enter the details</p>
        </div> */}
        <div className="drawer-style">
          <div className="form-group">
            <label>First Name</label>
            <input
              type="text"
              // className="form-control"
              className={`form-control ${errors.firstName ? 'is-invalid' : ''}`}
              value={AddformValues.firstName}
              onChange={(e) => {
                if (e.target.value.length <= 20) {
                handleAddUserInputChange("firstName", e.target.value)}
              }
            }
            />
            {errors.firstName && <div className="invalid-feedback">{errors.firstName}</div>}
          </div>
          <div className="form-group">
            <label>Last Name</label>
            <input
              type="text"
              // className="form-control"
              className={`form-control ${errors.lastName ? 'is-invalid' : ''}`}
              value={AddformValues.lastName}
              onChange={(e) =>{
                if (e.target.value.length <= 20) {
                handleAddUserInputChange("lastName", e.target.value)}
              }
            }
            />
            {errors.lastName && <div className="invalid-feedback">{errors.lastName}</div>}
          </div>
          <div className="form-group">
            <label>Email</label>
            <input
              type="email"
              className={`form-control ${errors.email ? 'is-invalid' : ''}`}
              value={AddformValues.email}
              onChange={(e) => handleAddUserInputChange("email", e.target.value)}
            />
            {errors.email && <div className="invalid-feedback">{errors.email}</div>}
          </div>
          <div className="form-group">
            <label>Password</label>
            <div className="position-relative">
            <input
              type={`${showPassword ? "text" : "password"}`}
              className={`form-control ${errors.password ? 'is-invalid' : ''}`}
              id="password"
              value={AddformValues.password}
              onChange={(e) => handleAddUserInputChange("password", e.target.value)}
            />
             {errors.password && <div className="invalid-feedback">{errors.password}</div>}
             {/* {!errors.password  &&( */}
             <div
                  className="icon-eye"
                  onClick={() => {
                    setShowPassword(!showPassword);
                  }}
                >
              
                  <img src={showPassword ? eyeOpen : eyeClose} alt="" style={{width:'15px'}} />
                </div>
                {/* )} */}
                
              </div>
           
          </div>
          <div className="form-group">
            <label>Role</label>
            <div>
              <Radio
                checked={AddformValues.role === "admin"}
                onChange={() => handleAddUserInputChange("role", "admin")}
              >
                Admin
              </Radio>
              <Radio
                checked={AddformValues.role === "user"}
                onChange={() => handleAddUserInputChange("role", "user")}
              >
                User
              </Radio>
            </div>
          </div>
        </div>
        <div className="d-flex align-items-center justify-content-end w-100 mt-4">
          <button className="me-4 btn-outline-secondary btn" onClick={onClose}>
            Cancel
          </button>
          <button className="btn btn-primary" onClick={handleAddUserSubmit}>
            Add
          </button>
        </div>
      </Drawer>
            {/*  */}
            

            <DeleteConformation
          isVisible={isDeleteModalVisible}
          onCancel={handleDeleteModalCancel}
          onConfirm={customDelete}
          message="Are you sure you want to delete this user?"
        />

        <DeleteConformation
          isVisible={isMultiDeleteModalVisible}
          onCancel={handleMultiDeleteCancel}
          onConfirm={handleMultipleDelete}
          message="Are you sure you want to delete the selected users?"
        />

        </>

        
    )
}

export default UserManagement